export default __webpack_public_path__ + "4a922088baf4dae9eb229f8c4d42810e.jpg";